import { motion } from "motion/react";
import type { ReactNode } from "react";
import { cn } from "#/lib/utils";
import { sectionClass } from "./landing-styles";
import { fadeBlurUp } from "#/components/ui/motion-primitives";

const innerSectionClass = "px-[18px] py-[42px] md:px-[42px]";
const kickerClass =
	"m-0 text-body1-bold uppercase text-[var(--primary)]";
const titleClass =
	"m-0 text-display2 text-foreground";
const bodyClass =
	"mt-[18px] text-title2-medium text-muted-foreground";

export function SectionBlock({
	id,
	label,
	title,
	description,
	centered = false,
	children,
}: {
	id: string;
	label: string;
	title: ReactNode;
	description: ReactNode;
	centered?: boolean;
	children: ReactNode;
}) {
	return (
		<section id={id} className={sectionClass}>
			<motion.div
				className={cn(
					innerSectionClass,
					centered && "max-w-none pt-11 text-center md:pt-[68px]",
					!centered && "max-w-[920px]",
				)}
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true, margin: "-40px" }}
				transition={{ staggerChildren: 0.1 }}
			>
				<motion.p
					className={kickerClass}
					variants={fadeBlurUp}
					transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
				>
					{label}
				</motion.p>
				<motion.h2
					className={titleClass}
					variants={fadeBlurUp}
					transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
				>
					{title}
				</motion.h2>
				<motion.p
					className={cn(bodyClass, centered && "mx-auto max-w-[780px]")}
					variants={fadeBlurUp}
					transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
				>
					{description}
				</motion.p>
			</motion.div>
			{children}
		</section>
	);
}
